export const initialState = {
  shipmentId: null,
  quotationsAvailable: null,
  page: 1,
  paymentLocation: null,
  manageSuggestion: false,
  addressBook: [],
  companyName: "",
  showBackgroundLoader: false,
  lastShipmentRequestTime: null,
  lastQuoteRequestTime: null,
};

/**
 * Reset the store to its initial state
 * @returns {Object} - The initial state of the store
 */
export const resetState = () => initialState;

// TODO: Add comment
export const handleSuggestionExpand = (state: any, payload: any) => ({
  ...state,
  manageSuggestion: payload.manageSuggestion,
});

// TODO: Add comment
export const persistPage = (state: any, payload: any) => ({
  ...state,
  page: payload.page,
});

// TODO: Add comment
export const updateShipmentId = (state: any, payload: { shipmentId: string }) => ({
  ...state,
  shipmentId: payload.shipmentId,
});

// TODO: Add comment
export const updateShipmentIdAndTitle = (state: any, payload: { shipmentId: string; shipmentTitle: string }) => ({
  ...state,
  shipmentId: payload.shipmentId,
  shipmentTitle: payload.shipmentTitle,
});

// TODO: Add comment
export const updateAddressBookData = (state: any, payload: any) => ({
  ...state,
  addressBook: payload.addressBook,
});

export const updateCompanyName = (state: any, payload: { companyName: string }) => ({
  ...state,
  companyName: payload.companyName,
});

export const updateBackgroundLoadingState = (state: any, isBackgroundLoading: boolean) => ({
  ...state,
  showBackgroundLoader: isBackgroundLoading,
});

export const updateLastShipmentRequestTime = (state: any, payload: { lastShipmentRequestTime: number | null }) => ({
  ...state,
  lastShipmentRequestTime: payload.lastShipmentRequestTime,
});

export const updateLastQuoteRequestTime = (state: any, payload: { lastQuoteRequestTime: number | null }) => ({
  ...state,
  lastQuoteRequestTime: payload.lastQuoteRequestTime,
});

export const updateLastInvoiceRequestTime = (state: any, payload: { lastInvoiceRequestTime: number | null }) => ({
  ...state,
  lastQuoteRequestTime: payload.lastInvoiceRequestTime,
});
